import type {Component} from 'vue';

interface SliceWithVariation {
    variation?: string | null;
}

export type VariationComponents<TComponent extends Component = Component> = Record<string, TComponent> & {
    default: TComponent;
};

export function getSliceVariationComponent<TComponent extends Component>(
    slice: SliceWithVariation,
    variationComponents: VariationComponents<TComponent>,
): TComponent {
    const {variation} = slice;

    if (variation && variation in variationComponents) {
        return variationComponents[variation] as TComponent;
    }

    return variationComponents.default;
}
